export default __webpack_public_path__ + "static/media/two-people-using-laptop-meeting-coffee-shop.939fc549.jpg";